import InvoiceAutomationJobMonthRuleEnum from './InvoiceAutomationJobMonthRuleEnum';

// Which month a job belongs to, worded to be read inside the setup page's sentence "Each job goes on the draft of the
// month …". The setup form's own labels are InvoiceAutomationJobMonthRuleOptionsArray.
const InvoiceAutomationJobMonthRuleSentenceOptionsArray = [
  { value: InvoiceAutomationJobMonthRuleEnum.DateDone, label: 'its shop date falls in' },
  { value: InvoiceAutomationJobMonthRuleEnum.PrismRunStart, label: 'its Prism run started in' },
  { value: InvoiceAutomationJobMonthRuleEnum.DateAdded, label: 'it becomes Ready for Invoicing in' },
];

export default InvoiceAutomationJobMonthRuleSentenceOptionsArray;
